<template>
  <div class="capacities" id="capacities">
    <section class="capacities__section">
      <h2>Capacities</h2>
      <div class="capacities__table__container">
        <table class="capacities__table">
          <tbody>
            <tr>
              <td>Access Steelwork</td>
              <td>Contract work of any volume</td>
            </tr>
            <tr>
              <td>Guillotine</td>
              <td>13mm x3m</td>
            </tr>
            <tr>
              <td>Plasma Cutting</td>
              <td>25mm</td>
            </tr>
            <tr>
              <td>1.2m Press Brake</td>
              <td>25tn</td>
            </tr>
            <tr>
              <td>2.5m Press Brake</td>
              <td>60tn</td>
            </tr>
            <tr>
              <td>Horizontal Press Brake</td>
              <td>40tn</td>
            </tr>
            <tr>
              <td>Machine Moving</td>
              <td>Up to 10t with ease. Skates rated to 20t.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <img
        class="capacities__square__bottom__right"
        src="@/images/rectangles-capacities-bottom-right.png"
        alt="square-shape"
      />
    </section>
  </div>
</template>

<script>
export default {
  name: 'Capacities',
}
</script>
